// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kSOK","colMin":"styles_colMin__3OIzj"};